import _ from 'lodash';
import { EventBus } from '../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../core/infraestructure/ItemComponent';
import AccountSubscriptionViewModel from '../../../core/features/authentication/viewmodels/AccountSubscriptionViewModel';

// 0: PLANES | 1: PAGO | 2: RESUMEN
const TOTAL_STEPS = 3;

export default {
    extends: ItemComponent,
    data() {
        return {
            modulePermissions: 'SubscriptionsContent-Subscriptions',
            viewModel: null,
            subscriptionPlans: [],
            discountCode: null,
            planSelected: null,
            paymentMethodType: 'subscriptionCode',
            currentStep: 0,
            totalSteps: TOTAL_STEPS,
            isLoading: false,
            subscriptionDetails: null,
            subscriptionSuccess: null,
            account: null,
            rules: {
            }
        }
    },
    props: {
        conf: {
            type: Object,
            required: true
        },
        formData: {
            type: Object,
            required: true
        }
    },
    created() {
        this.viewModel = new AccountSubscriptionViewModel(this);
        this.viewModel.onBindSubscriptions()
    },

    mounted() { },
    methods: {
        onSubmitForm(form) {
            this.viewModel.doSubscription({
                planId: this.planSelected,
                discountCode: this.discountCode,
                paymentMethod: this.viewModel.getPaymentMethod(this.paymentMethodType)
            })
        },
        onSearchSubscriptionPlansResponse(response) {
            this.subscriptionPlans = response;
        },
        formatMoney(amount) {
            return this.viewModel.formatMoney(amount)
        },
        // --- Wizard (controlado por estado de Vue, sin plugin jquery-steps) ---
        isStepActive(index) {
            return index === this.currentStep;
        },
        isStepDone(index) {
            return index < this.currentStep;
        },
        onNextStep() {
            if (this.currentStep >= this.totalSteps - 1) return;
            this.goToStep(this.currentStep + 1);
        },
        onPrevStep() {
            if (this.currentStep <= 0) return;
            this.goToStep(this.currentStep - 1);
        },
        goToStep(index) {
            if (index < 0 || index >= this.totalSteps) return;
            if (index === this.currentStep) return;
            // Hacia atrás siempre se permite
            if (index < this.currentStep) {
                this.currentStep = index;
                return;
            }
            // Hacia adelante hay que validar cada paso intermedio
            if (!this.canReachStep(index)) return;
            this.currentStep = index;
        },
        canReachStep(target) {
            for (let index = this.currentStep; index < target; index++) {
                if (!this.subscriptionValidation(index)) return false;
            }
            return true;
        },
        subscriptionValidation(currentIndex) {
            if (currentIndex === 0) return !_.isEmpty(this.planSelected);
            if (currentIndex === 1) {
                // El código de descuento solo es obligatorio en efectivo,
                // misma regla que aplica el backend (DoSubscription.CommandValidator).
                if (this.paymentMethodType !== 'subscriptionCode') return true;
                return this.hasDiscountCode();
            }
            return false;
        },
        hasDiscountCode() {
            return typeof this.discountCode === 'string' && this.discountCode.trim().length > 0;
        },
        onPaySubscription() {
            if (this.isLoading) return;
            this.isLoading = true;
            this.onSubmitForm();
        },
        onSubscriptionFinish() {
            this.discountCode = null;
            this.planSelected = null;
            this.currentStep = 0;
            this.conf.isVisible = false;
            EventBus.$emit('onFinishSubscriptionPayment', this.subscriptionDetails);
            this.subscriptionDetails = null;
        },
        onDoSubscriptionResponse(response) {
            setTimeout(() => {
                this.subscriptionDetails = response.data;
            }, 400);
            setTimeout(() => {
                this.isLoading = false;
            }, 600);
        },
        onDoSubscriptionError(error) {
            setTimeout(() => {
                this.isLoading = false;
            }, 400);

            var that = this;

            setTimeout(() => {
                var messages = this.getErrorMessages(error);

                messages.forEach(function (message) {
                    setTimeout(() => {
                        // that.viewModel.showNotification("warning", "Advertencia", message);
                        that.$confirm(message, 'Error', {
                            cancelButtonText: 'Aceptar',
                            type: 'error',
                            showConfirmButton: false,
                            cancelButtonClass:'btn-cancel'
                        })
                        .then(() => {

                        })
                        .catch(() => {

                        });

                    }, 150);
                });
            }, 600);
        },
        /**
         * Extrae los mensajes legibles de la respuesta de error.
         * El backend responde { statusCode, message }; también se contempla
         * el formato de ValidationProblemDetails ({ errors: { campo: [msgs] } }).
         */
        getErrorMessages(error) {
            const fallback = 'No fue posible completar la inscripción. Intente nuevamente.';
            const data = (error && error.response && error.response.data) ? error.response.data : null;

            if (!data) {
                return [fallback];
            }

            if (typeof data.message === 'string' && data.message.trim().length > 0) {
                // El backend antepone el nombre de la propiedad: "DiscountCode: mensaje".
                return [data.message.replace(/^[A-Za-z][A-Za-z0-9]*:\s*/, '')];
            }

            if (data.errors) {
                var messages = _.flattenDeep(_.toArray(data.errors));
                if (messages.length > 0) {
                    return messages;
                }
            }

            return [fallback];
        },
        getPaymentMethodName() {
            if(this.paymentMethodType === 'subscriptionCode') return 'Efectivo'
        },
        getSubscriptionPlanMethodName() {
            var plan = _.find(this.subscriptionPlans, {id: this.planSelected });
            return (plan) ? plan.name : 'Sin Plan'
        },
        onHideBackButton() {
            return !this.subscriptionDetails;
        },
        onShowFinishButton() {
            return this.subscriptionDetails;
        },
        selectPlan(planId) {
            this.planSelected = planId;
        }
    },
    computed: {
        selectedPlan() {
            return (this.subscriptionPlans && Array.isArray(this.subscriptionPlans))
                ? this.subscriptionPlans.find((p) => p.id === this.planSelected) || null
                : null;
        },
        canAdvanceStep() {
            return this.subscriptionValidation(this.currentStep);
        }
    }
}
